import React, { useState, useEffect } from 'react';
import { Box, IconButton, Paper, Typography, alpha, Tooltip } from '@mui/material';
import { Icon } from '@iconify/react';
import Filter from '../../component/chargeMiles/Filter';
import { useLocation } from 'react-router-dom';

export default function GlobalHamburger() {
  const currentLocation = useLocation();
  const isMapPage = currentLocation.pathname === '/' || currentLocation.pathname === '/home';
  const [open, setOpen] = useState(false); // Always start closed

  // Close menu automatically when the route changes
  useEffect(() => {
    setOpen(false);
  }, [currentLocation.pathname]);

  // Don't render on the map/home page — SearchBar already has its own menu trigger
  if (isMapPage) {
    return null;
  }

  const handleToggle = () => setOpen(prev => !prev);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box
        onClick={handleToggle}
        sx={{
          position: 'fixed',
          top: 24,
          left: 24,
          zIndex: 1400,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
          bgcolor: 'primary.main',
          color: '#fff',
          borderRadius: '12px',
          px: 2,
          py: 1,
          boxShadow: (theme) => `0 8px 16px 0 ${alpha(theme.palette.grey[500], 0.16)}`,
          background: 'linear-gradient(135deg, var(--app-color) 0%, #103996 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #103996 0%, var(--app-color) 100%)',
          },
          transition: 'all 0.2s ease-in-out'
        }}
      >
        <Icon icon="eva:menu-fill" width={22} height={22} />
        <Typography variant="subtitle2" sx={{ fontWeight: 700, letterSpacing: 1, userSelect: 'none' }}>
          MENU
        </Typography>
      </Box>

      {open && (
        <>
          {/* Invisible backdrop: clicking outside the menu closes it */}
          <Box
            onClick={handleClose}
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1299,
              bgcolor: 'transparent',
            }}
          />
          <Paper
            elevation={8}
            sx={{
              position: 'fixed',
              top: '80px',
              left: '16px',
              margin: '8px 0',
              zIndex: 1300,
              borderRadius: '12px',
              overflow: 'auto',
              maxHeight: 'calc(100vh - 104px)',
              width: 360,
              pt: 2,
              transition: 'all 0.3s ease-in-out'
            }}
          >
            <Box sx={{ px: 2, display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title="Close Menu" placement="bottom">
              <IconButton onClick={handleClose} size="small">
                <Icon icon="eva:close-fill" width={20} height={20} />
              </IconButton>
              </Tooltip>
            </Box>
            <Filter
              isMapPage={false}
              onRequestClose={handleClose}
              onDirectionHandler={() => {}}
              onFavouriteClick={() => {}}
            />
          </Paper>
        </>
      )}
    </>
  );
}
